import { useMutation } from "@tanstack/react-query";
import { api } from "../config";
import { MOLONI_BASE_PATH } from "./moloniApi";

const getDocumentPdf = async (documentId: number | string) => {
    const response = await api({
        method: "GET",
        url: `${MOLONI_BASE_PATH}/pdf`,
        params: {
            document_id: documentId,
        },
    });

    return response.data;
};

export const useDocumentPdf = () => {
    return useMutation({
        mutationFn: (documentId: number | string) => getDocumentPdf(documentId),
        onSuccess: (data) => {
            if (data?.url) {
                window.open(data.url, "_blank");
            }
        },
    });
};

